export default class StoreService {
  constructor() {}

  static get(key) {
    return JSON.parse(localStorage.getItem(key) ?? "{}");
  }

  static save(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  static clearForm(key) {
    localStorage.removeItem(key);
  }
}
